// extracted by mini-css-extract-plugin
export default {"create_collection":"CreateCollection_create_collection__Ez4IX","btn":"CreateCollection_btn__obuFN"};